export const css = {
	root: '_3XV5GwDc',
	node: '_13TdVKjN',
	nodeParent: '_30VnyH3X',
	contentWrapper: 'HBjyaBkt',
	content: '_2JfUI2Ps',
	leaf: '_2SYuxxlb',
	title: '_1lavvVzt',
	expander: 'B7FoMmOh',
	' _key': 'certwise-theme/dojo/tree'
};

export default css;
